/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiNoteTemplateFromJSON, StreemApiNoteTemplateToJSON, } from './';
export function StreemApiCreateNoteTemplateResponseFromJSON(json) {
    return StreemApiCreateNoteTemplateResponseFromJSONTyped(json, false);
}
export function StreemApiCreateNoteTemplateResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'noteTemplate': !exists(json, 'note_template') ? undefined : StreemApiNoteTemplateFromJSON(json['note_template']),
    };
}
export function StreemApiCreateNoteTemplateResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'note_template': StreemApiNoteTemplateToJSON(value.noteTemplate),
    };
}
//# sourceMappingURL=StreemApiCreateNoteTemplateResponse.js.map